import { DbCreateBreakageReport } from "../../../data/usecases/created-breakage-report";
import { CreateBreakageReport } from "../../../domain/usecases/create-breakage-report";

import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbCreateBreakageReport = (): CreateBreakageReport =>
  new DbCreateBreakageReport(
    makeApiUrl("/breakage"),
    makeAuthorizeHttpClientDecorator()
  );
